import React from 'react';
import { Checkbox, HStack, IconButton, Spacer } from '@cardboard-ui/react';
import { ItemProps } from './index';
import { ItemMenu } from './ItemMenu';
import { ItemHandle, UploadingItemHandle } from 'components/ItemHandle';
import { t } from '@lingui/macro';
import { CloseIcon } from 'components/icons';

interface ListItemProps extends ItemProps {
  linkBox?: boolean;
}

export const ListItem = ({
  node,
  uploadName,
  isLoading,
  loadingPercentage,
  isFailed,
  isVirus,
  parentConnectionId,
  cancelUpload,
  linkBox,
  isSelected,
  onSelectChange,
}: ListItemProps) => {
  return (
    <HStack w="100%" data-qa="item" spacing={0.5}>
      {onSelectChange && (
        <Checkbox
          p={2}
          me={2}
          isChecked={isSelected}
          onChange={onSelectChange}
        />
      )}
      {isLoading || isFailed ? (
        <UploadingItemHandle
          uploadName={uploadName}
          loadingPercentage={loadingPercentage}
          isFailed={isFailed}
          isVirus={isVirus}
        />
      ) : (
        node && <ItemHandle item={node} linkBox={linkBox} />
      )}
      <Spacer />
      {!isLoading && node && (
        <ItemMenu
          node={node}
          mode="list-item"
          connectionId={parentConnectionId}
        />
      )}
      {cancelUpload && (
        <IconButton
          borderRadius="full"
          onClick={cancelUpload}
          aria-label={t`Cancel Upload`}
        >
          <CloseIcon />
        </IconButton>
      )}
    </HStack>
  );
};
